import React, { forwardRef, useState, useEffect, useImperativeHandle } from "react";
import { getQueryUTMString } from '@tw/shared-ui-components/lib/utils/helper';
import {
    getMarkupPurchaseInfo,
    setMarkupPurchaseInfo,
    removeMarkupPurchaseInfo,
    setMarkupMaxQuantityInfo,
    setMarkupPurchaseQuantity
} from '../../utils/helper'
import NewSpinner from "../newSpinner/newSpinner";
import PropTypes from "prop-types";
import scss from "./markupPurchaseDashboard.scss";
import {
    MARKUP_ACTIVITY_INFO,
} from '../../utils/Constants/Constants'
const MarkupPurchaseDashboard = forwardRef(
    (props, ref) => {
        const {
            onChangeCallback,
            onDeleteCallback,
            itemCode,
            pageType,
            moduleId,
            activityDetails,
            itemMaxQuantity,
            itemCodes,
            defaultItemCodes,
            openPlpCallback,
            btnLoading,
            markupAdminPurchaseQuantity
        } = props;
        const [quantity, setQuantity] = useState(0);
        const [totalOrderPrice, setTotalOrderPrice] = useState(0);
        const intlNumberFormatter = new Intl.NumberFormat("en-US");
        useEffect(() => {
            if (typeof window !== 'undefined') {
                initComponentsData()
            }
        }, [])
        useImperativeHandle(ref, () => ({
            onReset() {
                setTimeout(() => {
                    initComponentsData()
                }, 1000)
            },
        }));
        const initComponentsData = () => {
            let arr = []
            let totalPrice = 0;
            const markupPurchaseList = getMarkupPurchaseInfo();
            if (JSON.stringify(markupPurchaseList) !== "{}" && markupPurchaseList[`${moduleId}_${itemCode}`]) {
                markupPurchaseList[`${moduleId}_${itemCode}`].map((item) => {
                    let json = {};
                    json.itemCode = item.itemCode;
                    json.price = item.price;
                    json.quantity = item.quantity;
                    json.totalPrice = Number(item.price) * Number(item.quantity);
                    totalPrice = Number(totalPrice) + (Number(item.price) * Number(item.quantity))
                    arr.push(json)
                })
            }
            setQuantity(arr.reduce((accumulator, currentItem) => Number(accumulator) + Number(currentItem.quantity), 0))
            setTotalOrderPrice(totalPrice)
            onChangeCallback({ quantity: arr.length, totalPrice })
        }
        //  跳转加价购 PLP 页面
        const openmarkupPurchasePlp = () => {
            if (typeof window !== 'undefined' && !btnLoading) {
                switch (pageType) {
                    case "PDP":
                        sessionStorage.setItem(MARKUP_ACTIVITY_INFO, JSON.stringify(activityDetails))
                        setMarkupMaxQuantityInfo(itemMaxQuantity)
                        setMarkupPurchaseQuantity({ quantity: markupAdminPurchaseQuantity, itemCode: itemCode })
                        window.location.href = `/markup-purchase-products?callback_url=${encodeURIComponent(window.location.href)}&itemCode=${itemCode}&pageType=${pageType}${getQueryUTMString("&")}&moduleId=${moduleId}&itemCodeList=${itemCodes}`
                        break;
                    case "CART":
                        openPlpCallback()
                        break;
                }

            }
        }
        //  删除
        const deleteGoods = () => {
            const markupPurchaseList = getMarkupPurchaseInfo();
            if (JSON.stringify(markupPurchaseList) !== "{}" && pageType == "PDP" && markupPurchaseList[`${moduleId}_${itemCode}`]) {
                let json = { ...markupPurchaseList }
                delete json[`${moduleId}_${itemCode}`]
                setQuantity(0)
                setTotalOrderPrice(0)
                if (JSON.stringify(json) !== "{}") {
                    setMarkupPurchaseInfo(json)
                    onDeleteCallback(json)
                } else {
                    removeMarkupPurchaseInfo()
                    onDeleteCallback({})
                }
            } else {
                onDeleteCallback(defaultItemCodes)
            }
        }
        return (
            <>
                <div className={scss.Index_container}>
                    <div className={scss.container_details}>
                        <div className={scss.title_text}>商品加價購</div>
                        <div className={scss.info}>
                            <span>件數  {quantity}</span>
                            <span>總額  {intlNumberFormatter.format(Number(totalOrderPrice))}</span>
                        </div>
                        {
                            (Number(quantity) > 0 || Number(totalOrderPrice) > 0) && <div className={scss.delete} onClick={deleteGoods}>刪除全部</div>
                        }
                    </div>

                    <a
                        href={"javascript:void(0);"}
                        onClick={openmarkupPurchasePlp}
                        className={scss.ToPickAHorse}
                        style={{ background: btnLoading ? '#a6552399' : '#A65523' }}
                    > {btnLoading ? <NewSpinner size="sm" /> : '前往挑選'} </a>

                </div>
            </>
        );
    }
)
MarkupPurchaseDashboard.defaultProps = {
    //  cart 页面默认已在购物车的商品
    defaultItemCodes: [],
    //  加价购 PLP 需要的文字描述、商品最大选择数量信息
    activityDetails: [],
    //  加价购 PLP 商品最大可選數量枚舉
    itemMaxQuantity: {},
    //  加价购 PLP 商品列表接口入参。命中的加价购商品itemCode
    itemCodes: [],
    //  当前组件ID ｜ 用于区分多个价格活动
    moduleId: "",
    //  当前商品ID
    itemCode: "",
    //  当前所在页面
    pageType: "PDP",
    //  數據發生變化時觸發
    onChangeCallback: () => { },
    //  全部删除
    onDeleteCallback: () => { },
    //  购物车页面点击“前往挑選”按钮触发
    openPlpCallback: () => { },
    //  重置看板數據
    onReset: () => { },
};
MarkupPurchaseDashboard.propTypes = {
    activityDetails: PropTypes.array,
    itemCodes: PropTypes.array,
    defaultItemCodes: PropTypes.array,
    moduleId: PropTypes.string,
    itemCode: PropTypes.string,
    pageType: PropTypes.string,
    onChangeCallback: PropTypes.func,
    onDeleteCallback: PropTypes.func,
    openPlpCallback: PropTypes.func,
    onReset: PropTypes.func,
};
export default MarkupPurchaseDashboard;
